import { z } from 'zod';
import { api } from './api';
import {
  adjustmentSchema,
  alertsResponseSchema,
  auditPageSchema,
  commentSchema,
  valueDetailSchema,
  type Adjustment,
  type AlertsResponse,
  type AuditPage,
  type CommentItem,
  type ValueDetail,
} from '@/types/collab';

export const adjustmentsService = {
  list: (unitId: string, periodId: string, categoryId?: string): Promise<Adjustment[]> =>
    api.get(
      `/adjustments?business_unit_id=${unitId}&period_id=${periodId}${categoryId ? `&category_id=${categoryId}` : ''}`,
      z.array(adjustmentSchema),
    ),
  create: (input: {
    business_unit_id: string;
    financial_period_id: string;
    financial_category_id: string;
    adjustment_value: string;
    reason: string;
  }): Promise<Adjustment> => api.post('/adjustments', adjustmentSchema, input),
};

export const commentsService = {
  list: (params: {
    business_unit_id?: string;
    period_id?: string;
    category_id?: string;
    import_id?: string;
  }): Promise<CommentItem[]> => {
    const query = new URLSearchParams(
      Object.entries(params).filter(([, value]) => value) as [string, string][],
    ).toString();
    return api.get(`/comments${query ? `?${query}` : ''}`, z.array(commentSchema));
  },
  create: (input: {
    body: string;
    business_unit_id?: string;
    financial_period_id?: string;
    financial_category_id?: string;
    import_id?: string;
  }): Promise<CommentItem> => api.post('/comments', commentSchema, input),
};

export const auditService = {
  list: (params: {
    action?: string;
    entity_type?: string;
    actor_id?: string;
    limit?: number;
    offset?: number;
  }): Promise<AuditPage> => {
    const query = new URLSearchParams(
      Object.entries(params)
        .filter(([, value]) => value !== undefined && value !== '')
        .map(([key, value]) => [key, String(value)]),
    ).toString();
    return api.get(`/audit${query ? `?${query}` : ''}`, auditPageSchema);
  },
};

export const alertsService = {
  list: (periodId?: string): Promise<AlertsResponse> =>
    api.get(`/alerts${periodId ? `?period_id=${periodId}` : ''}`, alertsResponseSchema),
};

export const valuesService = {
  detail: (unitId: string, categoryId: string, periodId: string): Promise<ValueDetail> =>
    api.get(
      `/business-units/${unitId}/values/${categoryId}?period_id=${periodId}`,
      valueDetailSchema,
    ),
};
